import React from 'react';
import './index.css';
import Toast from '../common/Toast'
import util from "../../util/tools";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weixinurl: "",
            bookId: "",
            hongbao:'',
            coin:'',
            text:''
        };
    }

    componentDidMount() {
        document.title = '金币充值'
        this.setState({
            bookId: this.props.match.params.bookId,
            weixinurl: this.props.match.params.weixinurl
        },()=>{
            this.getUserInfo()
        })
    }

    getUserInfo(){
        util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({
                        coin:data.user_money.coin,
                        hongbao:data.user_money.hongbao
                    })
                }
            }
        });
    }

    showText(text){
        this.setState({
            text:text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    text:"",
                })
            },2000)
        })
    }
    handleClick(){

    }

    recharge(item,index){
        if(!item){return false;}
        let url = this.state.weixinurl || `${document.location.href}`;
        let mineUrl = document.location.origin + '/mine';
        let params = {
            'total_fee':item*100,
            'back_url':mineUrl,
            'error_url': url,
            'doubleone': 1
        }
        if(!!this.state.bookId){
            params.book_id = this.state.bookId
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                }else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    goRoute(){
        this.props.history.push('/balance')
    }

    render() {
        return (
            <div className='dubleonerecharge'>
                <div className='recharge' >
                    <img  src={require(`../../../common/images/dubleBg1.png`)} />
                    <div className="btnfirst">
                        <img  src={require(`../../../common/images/dubleBg2.png`)}  onClick={()=>this.recharge(11.11)}/>
                    </div>
                    <div className="btnlast">
                        <img  src={require(`../../../common/images/dubleBg3.png`)} onClick={()=>this.recharge(51.11)}/>
                    </div>
                </div>
                <Toast text={this.state.text}/>
            </div>
        );
    }
}